import React from 'react';

// Pagination : précédent / suivant et numéros de pages (avec « … » quand il y en a beaucoup)
function pageList(page, pages) {
  const set = new Set([1, pages, page - 1, page, page + 1]);
  const nums = [...set].filter(n => n >= 1 && n <= pages).sort((a, b) => a - b);
  const out = [];
  nums.forEach((n, i) => { if (i && n - nums[i - 1] > 1) out.push('…' + n); out.push(n); });
  return out;
}

export default function Pagination({ page, pages, onPage }) {
  if (pages <= 1) return null;
  return (
    <nav className="pagination" aria-label="Pagination">
      <button type="button" className="pg-btn" disabled={page <= 1} onClick={() => onPage(page - 1)} aria-label="Page précédente">← précédent</button>
      <ul>
        {pageList(page, pages).map(n => typeof n === 'string'
          ? <li key={n} className="pg-gap" aria-hidden="true">…</li>
          : <li key={n}><button type="button" className={`pg-btn ${n === page ? 'on' : ''}`} aria-current={n === page ? 'page' : undefined}
              onClick={() => onPage(n)} aria-label={`Page ${n}`}>{n}</button></li>)}
      </ul>
      <button type="button" className="pg-btn" disabled={page >= pages} onClick={() => onPage(page + 1)} aria-label="Page suivante">suivant →</button>
    </nav>
  );
}
